import { render, staticRenderFns } from "./fun.vue?vue&type=template&id=712dc63d&scoped=true"
import script from "./fun.vue?vue&type=script&lang=js"
export * from "./fun.vue?vue&type=script&lang=js"
import style0 from "./fun.vue?vue&type=style&index=0&id=712dc63d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712dc63d",
  null
  
)

export default component.exports